import { useEffect, useState } from "react";

import { decoColumns } from "./misc/deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useSurveys = () => {
    const { platformId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });

    const { getSearchParams } = useSearchParams();
    const [data, setData] = useState({ surveys: [], pagination: {} });

    const [queryParams, setQueryParams] = useState({});
    const [modalConfig, setModalConfig] = useState({ row: {}, isOpen: false });
    const [isOpen, setIsOpen] = useState(false);

    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => {
            return { row, isOpen: !prev.isOpen };
        });
    };

    //ToDo: update the pagination once it will be consistent from BE
    const getAllSurveys = async () => {
        const { data, pagination } = await axiosInstance.get(`/survey/${platformId}`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });
        setData({
            surveys: data,
            pagination
        });
    };

    const handleRowActions = async (row = {}, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/survey/${platformId}/${row._id}/`);
            getAllSurveys();
            return;
        }       
        handleModalConfig(row);
    };

    const sendSurvey = async survey_id => {
        await axiosInstance.post(`/survey/${platformId}/send/${survey_id}`, {});
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getAllSurveys();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    const handleAddSurvey = () => {
        setIsOpen(!isOpen);
    };

    const handleSurveyType = type => {
        handleAddSurvey();
        setModalConfig({ row: { survey_type: type }, isOpen: true });
        
    };

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions, sendSurvey }),
        modalConfig,
        getAllSurveys,
        setQueryParams,
        handleModalConfig,
        handleSurveyType,
        handleAddSurvey,
        isOpen
    };
};

export default useSurveys;
